<template>
    <div>
        <header-message class="mt-5 mb-5 text-success">Upgrade Successfully Installed</header-message>
        <header-message class="mt-5 mb-5">Please power off the device or restart the device using the Restart button</header-message>
        <div class="buttondiv mt-5 mb-5">
            <button-button class="btn btn-primary" type="submit" @click.prevent="restartClicked">Restart</button-button>
        </div>
        <power-off />
    </div>
</template>

<style scoped lang="scss">
    .buttondiv {
        text-align:center;
    }
</style>

<style lang="scss">
    .desc.status {
        font-size: 1.5rem;
        font-style: normal;
    }
</style>

<script lang="ts">

import { defineComponent } from "vue";

import PageBase from "@/shared/components/common/PageBase";
import HeaderMessage from "@/components/HeaderMessage.vue";
import PowerOff from "@/components/PowerOff.vue";

export default defineComponent({
    name: "UpgradeInstalled",
    mixins: [PageBase],
    components: {
        HeaderMessage,
        PowerOff,
    },
    methods: {
        restartClicked(): void {
            Auggie.System.Restart();
        },
    },
});
</script>
